/**
 * THE AXIOM GATE
 * 
 * This module acts as the linguistic firewall. 
 * It enforces Bantu Noun Class Concordance rules.
 * 
 * RULE 1 (The "Isi-Si" Axiom):
 * If a Class 7 noun (starts with 'isi-') acts as the subject, 
 * the immediate verb must carry the 'si-' subject concord.
 */

export interface AxiomResult {
  isValid: boolean;
  violations: string[];
}

export const validateZuluConcordance = (text: string): AxiomResult => {
  const violations: string[] = [];
  
  // Normalize text
  const cleanText = text.trim();
  const words = cleanText.split(/\s+/);

  for (let i = 0; i < words.length - 1; i++) {
    const word = words[i].toLowerCase();
    const nextWord = words[i + 1].toLowerCase();

    // Check for Class 7 Noun prefix 'isi-'
    // We ignore short words that might be coincidental (though 'isi' itself is valid, usually prefixes are attached)
    if (word.startsWith('isi') && word.length > 3) {
      
      // The Rule: The following word (Verb) MUST start with 'si-'
      // Logic: If next word does NOT start with 'si', it is a potential violation.
      if (!nextWord.startsWith('si')) {
        violations.push(
          `Violation detected: Noun '${words[i]}' (Class 7) is followed by '${words[i+1]}'. Expected a verb starting with 'si-'.`
        );
      }
    }
  }

  return {
    isValid: violations.length === 0,
    violations
  };
};